import React, { useEffect, useState } from "react";
import FormBuilder from "../../components/FormBuilder/FormBuilder";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { skeletonHandler } from "../../HandleSlice/HandleSlice";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CreateSkeleton from "../../components/CreateSkeleton/CreateSkeleton";
import useFormStore from "../../store/formData";

const DynamicEditDetailExpertReport = () => {
  const [newData, setNewData] = useState({});
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = useLocation();
  const data = useSelector((data) => data.hamberger);
  const { formData, setFormData, clearFormData } = useFormStore();

  const splitPathName = pathname.pathname.split("/")[1];
  let queryFetch = "";

  if (splitPathName === "visit-expert-detail-seller") {
    queryFetch = `?inspection_section=car_sale&expert_report_code=${JSON.parse(localStorage.getItem("expertItem"))?.expert_report_code}`;
  } else if (splitPathName === "visit-expert-detail-buyer") {
    queryFetch = `?inspection_section=car_purchase&expert_report_code=${JSON.parse(localStorage.getItem("expertItem"))?.expert_report_code}`;
  }

  const expertBuyerUrl = pathname?.pathname.startsWith(
    "/visit-expert-detail-buyer/",
  );
  const expertSellerUrl = pathname?.pathname.startsWith(
    "/visit-expert-detail-seller/",
  );

  const viewAttributeUrl = pathname?.pathname.startsWith(
    "/view-attribute-group-expert/",
  );

  const viewAttributeRequestUrl = pathname?.pathname.startsWith(
    "/view-attribute-group-expert-request/",
  );

  const updatedApi =
    expertBuyerUrl || expertSellerUrl
      ? `/advertise/${params.id}/attribute-groups/${params.model}/expert_id/${localStorage.getItem("expertId")}${queryFetch}`
      : viewAttributeUrl
        ? `/show-expert-report/${params.id}/${params.model}`
        : viewAttributeRequestUrl
          ? `/show-expert-request-report/${params.id}/${params.model}`
          : "";

  useEffect(() => {
    dispatch(skeletonHandler(true));
    axios(updatedApi)
      .then((response) => {
        if (response?.status === 200) {
          setNewData(response.data);
          response.data.data.attribute_value.map((item) => {
            setFormData(item.attribute_id, item.value);
          });
        }
      })
      .then(() => {
        dispatch(skeletonHandler(false));
      })
      //TODO 404 500
      .catch((e) => {
        // if (e?.response?.status === 422) {
        // }
      });
  }, []);

  function submitHandler() {
    if (expertBuyerUrl || expertSellerUrl) {
      axios
        .post("/advertise/update/attribute-value-expert-detail", {
          advertise_id: params?.id,
          expert_id: localStorage.getItem("expertId"),
          items: formData,
        })
        .then((res) => {
          navigate(
            `/${pathname?.pathname.split("/")[1]}/edit/` +
              params?.id +
              pathname?.search,
          );
          clearFormData();
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (viewAttributeUrl) {
      axios
        .post("/expert-report/store-attribute-value", {
          expert_request_price: params?.id,
          items: formData,
        })
        .then((res) => {
          navigate(
            `/${pathname?.pathname.split("/")[1]}/edit/` +
              params?.id +
              pathname?.search,
          );
          clearFormData();
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (viewAttributeRequestUrl) {
      axios
        .post("/expert-request-report/store-attribute-value", {
          expert_request: params?.id,
          items: formData,
        })
        .then((res) => {
          navigate(
            `/${pathname?.pathname.split("/")[1]}/edit/` +
              params?.id +
              pathname?.search,
          );
          clearFormData();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  return (
    <div className="bg-body_background w-[calc(100%)] dark:bg-[#152A38] 900:mr-[238px] 900:w-[calc(100%-238px)] pt-[90px] pb-5">
      <div
        className={`bg-component_background shadow-box dark:bg-[#29435C] rounded-[12px] px-[25px] pb-[25px] pt-2 sm:pt-[25px] m-auto mt-10`}
        style={{ width: `80%` }}
      >
        {newData?.data?.children?.map((item) => (
          <FormBuilder data={item} />
        ))}
        <div className="w-full mt-8 text-left px-4">
          <button
            className={`bg-confirm_button_background rounded-lg w-[100px] text-[#FEFEFE] text-sm font-medium py-3`}
            onClick={submitHandler}
          >
            تایید ادامه
          </button>
        </div>
        {data?.skeletonState && <CreateSkeleton />}
      </div>
    </div>
  );
};

export default DynamicEditDetailExpertReport;
